import React from "react";
import { toast } from "sonner";

const TAG_HELP = {
  CURRENTMONTH: "This month, e.g. June", NEXTMONTH: "Next month", LASTMONTH: "Last month", YEAR: "This year",
  NEXTMONTHYEAR: "Year of next month", CLIENT: "Client name", PROJECT: "Project name", NAME: "Group name", DOCNAME: "Doc name",
};
export const BASE_TAGS = ["CURRENTMONTH", "NEXTMONTH", "LASTMONTH", "YEAR", "NEXTMONTHYEAR", "CLIENT", "PROJECT"];

export const MergeTagHint = ({ tags = BASE_TAGS, testid = "merge-tags" }) => (
  <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
    <span className="text-[11px] text-[#595D62] mr-1">Merge tags (filled in on import):</span>
    {tags.map((t) => (
      <button type="button" key={t} title={`${TAG_HELP[t] || t} · click to copy`} data-testid={`${testid}-${t}`}
        onClick={() => {
          const v = `{${t}}`;
          if (!navigator.clipboard?.writeText) { toast.error(`Couldn't copy. Type ${v} instead`); return; }
          navigator.clipboard.writeText(v).then(() => toast.success(`Copied ${v}`)).catch(() => toast.error(`Couldn't copy. Type ${v} instead`));
        }}
        className="font-mono-data text-[10px] rounded-full border border-[#EEEFEF] bg-white px-2 py-0.5 text-[#5b2fd6] hover:border-[#C9B8FF] transition-colors">{`{${t}}`}</button>
    ))}
  </div>
);
